import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'logo-carousel',
  templateUrl: './logo-carousel.component.html',
  styleUrls: ['./logo-carousel.component.scss'],
})
export class LogoCarouselComponent implements OnInit {
  @Input() logoCarouselInfo: any;
  @Output() navigateToDetail = new EventEmitter<any>();
  constructor(
    private navController: NavController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}

  async navigate(productItem: any) {
    this.analyticsService.trackUnified('logo_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'logo_clicked',
      component: 'logo-carousel-component',
      button: 'logo',
    });
    if (productItem?.landingType === 'external_url') {
      await Browser.open({ url: productItem?.landingValue });
    }
    else if(productItem?.landingType === 'url'){
      this.navController.navigateForward(productItem?.landingValue);
    }
    else{
      this.navigateToDetail.emit(productItem);
    }
  }
  
}
